export default "__VITE_ASSET__a817126e__"